import React from "react";
import { Badge } from "../Base/Badge";
import type { MailIconProps } from "./MailIcon.types";
import "./MailIcon.scss";
import { MailTopRightIcon as MailSvgIcon } from "./IconSvgMap";

// 说明：为打破 components/Icon → modules/notification → modules/user → components
// 的巨型循环依赖，本组件保持 dumb，不再内部订阅消息未读数。
// 调用方（Header / usePageConfig 等）需自行通过 useMessageNotification 读取
// messageUnreadCount，并通过 `badgeContent` + `showBadge` props 传入。
// 如需"消息未读数自动联动"，请使用 `@/modules/notification` 下的
// `MailIconWithBadge` 包装组件（或自行在业务代码里组合）。
export const MailIcon: React.FC<MailIconProps> = ({
  badgeContent,
  showBadge,
  showDot = false,
  showCount = true,
  maxCount = 99,
  onBadgeClick,
  className = "",
  onClick,
  iconSrc,
}) => {
  const handleClick = () => {
    onBadgeClick?.();
    onClick?.();
  };

  // 提供 iconSrc 时用自定义图片替换默认邮件图标（如批量赠金通知图标）
  const glyph = iconSrc ? (
    <img
      src={iconSrc}
      alt=""
      className="mail-icon__image"
      style={{ objectFit: "contain" }}
      onClick={handleClick}
    />
  ) : (
    <MailSvgIcon
      width="100%"
      height="100%"
      className="mail-icon__image"
      onClick={handleClick}
    />
  );

  const finalBadgeContent = badgeContent;
  const finalShowBadge = showBadge ?? false;
  const numericUnread =
    typeof finalBadgeContent === "number" ? finalBadgeContent : 0;
  const shouldShowDot = showDot && !showCount && numericUnread > 0;
  const shouldShowCount =
    showCount && typeof finalBadgeContent === "number" && finalBadgeContent > 0;

  const displayContent =
    typeof finalBadgeContent === "number" && finalBadgeContent > maxCount
      ? `${maxCount}+`
      : finalBadgeContent;

  return (
    <div className={`mail-icon ${className}`.trim()}>
      {finalShowBadge ? (
        <Badge
          content={
            shouldShowDot
              ? undefined
              : shouldShowCount
                ? displayContent
                : undefined
          }
          dot={shouldShowDot}
          variant="error"
          size="sm"
          className="mail-icon__badge"
        >
          {glyph}
        </Badge>
      ) : (
        glyph
      )}
    </div>
  );
};

export default MailIcon;
